<script lang="ts" setup>
/* eslint-disable vue/no-unused-properties */

defineProps<{
  index: number;
}>();

</script>
<template>
  <slot/>
</template>
<style scoped>
</style>
